(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
jQuery('a[href^="http"]').not('a[href^="{{ shop.url }}"]').attr('target', '_blank');

  } catch(e) { console.error(e); }
})();
})();
